//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider, Tag, Select, Option, Col, Button, Upload, Checkbox, Badge} from 'element-ui'
import CyMobileLayout from '../../components/mobile/CyMobileLayout'
import CySelect from '../../components/select/CySelect'
import CyAutocomplete from '../../components/autocompletes/CyAutocomplete'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(Badge)
export default {
  name: 'StockInConfirm',
  components: {
    CyMobileLayout,
    CySelect,
    CyAutocomplete
  },
  data () {
    return {
      loginUser: this.$UserUtils.getAccessUser()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/WmsIndex.vue